
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy",
      function () {
        return require("private-next-pages/academy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy"])
      });
    }
  